
/**
 * Export `applications`.
 */

export const applications = {
  bathrooms: 'bathrooms',
  commerce: 'commerce',
  exteriorWallTiles: 'exteriorWallTiles',
  indoorFloorTiles: 'indoorFloorTiles',
  industry: 'industry',
  interiorWallTiles: 'interiorWallTiles',
  kitchens: 'kitchens',
  office: 'office',
  outdoorFloorTiles: 'outdoorFloorTiles',
  pools: 'pools',
  publicSpaces: 'publicSpaces',
  rehab: 'rehab',
  roomAndBedroom: 'roomAndBedroom',
  stations: 'stations',
  terraces: 'terraces'
};
